export type ChipProps = React.ComponentProps<'div'> & {
  size?: 'small' | 'medium' | 'large'
} & React.HTMLAttributes<HTMLDivElement>

export const Chip = ({ size = 'small', children, ...props }: ChipProps) => {
  if (!children) {
    return null
  }

  return (
    <div
      {...props}
      className={`flex items-center gap-2 font-sans ${
        size === 'small'
          ? 'rounded px-2 py-1 text-xs'
          : size === 'medium'
            ? 'rounded-lg px-3 py-1 text-sm'
            : 'rounded-xl px-4 py-3 text-base'
      } bg-mydra-violet font-medium leading-5 text-mydra-black ${!props.onClick ? 'cursor-default focus:outline-none' : ''} ${props.className ?? ''} `}
    >
      {children}
    </div>
  )
}
